function WcQuantity(el) {
    this.$el = $(el);
    this.val = parseInt($(el).attr("value"));
    this.step = parseInt($(el).attr("step"));
    this.min = parseInt($(el).attr("min"));
    this.max = parseInt($(el).attr("max"));
    $(el).find("a").click(function (ev) {
        ev.preventDefault();
    });
}
WcQuantity.prototype.updateVal = function (val) {
    if (val < this.min) {
        val = this.min;
    }
    if (val > this.max) {
        val = this.max;
    }
    this.val = val;
    this.$el.find("input").val(val);
    this.$el.find(".quantity_val").text(val);
};
export default WcQuantity;



// WEBPACK FOOTER //
// ./assets/js/wc_quantity.js